<template>
  <div style="padding:10px;overflow:auto;height:80vh">
    <el-container>
      <el-aside width="200px" class="asides">
        <el-scrollbar class="aside_scroll">
          <span>{{title}}</span>
          <el-tree
            :data="catalogtree"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
            :render-content="renderContent"
            highlight-current
            ref="tree"
            @node-click="nodeClick"
          ></el-tree>
        </el-scrollbar>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import { getProduct } from "../../../api/gm/api-product";
export default {
  //..数据
  data() {
    return {
      catalogtree: [],
      title: "",
      yuhudianji: false, //如果不是用户点击则默认加载第一个有内容的目录数据
      //第一个有内容的目录
      firstmulu: {
        tid: 0, //树id
        did: 0, //数据id
        type: 0 //内容类型
      },
      windowurl: [], //防止点击刷新重新跑到其他页面
      //有内容的目录类型
      datatype: [
        {
          value: 2,
          name: "列表",
          path: "/gm/product/content/list/" + this.$route.params.id
        },
        {
          value: 3,
          name: "单页",
          path: "/gm/product/content/info/" + this.$route.params.id
        },
        {
          value: 5,
          name: "选项卡",
          path: "/gm/product/content/tab/" + this.$route.params.id
        }
      ]
    };
  },
  //..初始
  created() {
    getProduct(this.$route.params.id).then(res => {
      if (res.code === 0) {
        this.title = res.data.name;
        this.catalogtree = res.data.catalogTree[0].children;
      } else {
        this.$message.error(res.msg);
      }
    });
  },
  updated: function() {
    this.$nextTick(function() {
      if (
        this.windowurl.indexOf(window.location.href) == -1 &&
        !this.yuhudianji
      ) {
        //跳转到第一个有数据的目录
        var managepath = this.getTypePath(this.firstmulu.type);
        if (managepath != "") {
          this.$refs.tree.setCurrentKey(this.firstmulu.did);
          this.$router.push({ path: managepath + "/" + this.firstmulu.did });
        }
      }
    });
  },
  //..方法
  methods: {
    //..点击节点
    nodeClick(item, node, self) {
      this.yuhudianji = true; //表示用户点击的
      var managepath = this.getTypePath(node.data.type);
      if (managepath == "") {
        managepath = "/gm/product/content/wu/" + this.$route.params.id;
      } else {
        managepath = managepath + "/" + node.data.id;
      }
      this.$router.push({ path: managepath });
    },
    //..获取内容管理地址
    getTypePath(type) {
      var path = "";
      this.datatype.filter(item => {
        if (item.value == type) {
          path = item.path;
          return;
        }
      });
      return path;
    },
    //..初始化树
    renderContent(h, { node, data, store }) {
      var managepath = this.getTypePath(node.data.type);
      if (managepath == "") {
        //没有管理地址
        return (
          <div class="nohave" width="100%">
            {node.label}
          </div>
        );
      } else {
        if (this.firstmulu.tid == 0 || node.id < this.firstmulu.tid) {
          //获取第一个有内容的目录
          this.firstmulu.tid = node.id;
          this.firstmulu.did = node.data.id;
          this.firstmulu.type = node.data.type;
        }

        let url =
          window.location.protocol +
          "//" +
          window.location.host +
          managepath +
          "/" +
          node.data.id;
        if (this.windowurl.indexOf(url) == -1) {
          this.windowurl.push(url);
        }
        if (url == window.location.href) {
          store.setCurrentNode(node);
        }

        return <div width="100%">{node.label}</div>;
      }
    }
  }
};
</script>
<style scoped>
.nohave {
  color: rgb(175, 170, 170);
}
.aside_scroll {
  height: 80vh;
}
.aside_scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/pages/gm/content/index.vue